.topFeelingsSection {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.topFeelingsContainer {
  display: flex;
  gap: 16px;
  overflow-y: auto;
}

.topFeelingsBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--colors-text-main);
  background-color: rgb(0 0 0 / 5%);
  border-radius: var(--border-radius-lg);
  padding-top: 12px;
  padding-bottom: 12px;
}
